(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-box-badge-with-timer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function startUrgencyTimers() {
      // Get all timer containers
      const timerContainers = document.querySelectorAll('.js-badge-timer');

      timerContainers.forEach((timerContainer, index) => {
        // Find timer elements within this specific container
        const hoursElement = timerContainer.querySelector('.js-timer-hours');
        const minutesElement = timerContainer.querySelector('.js-timer-minutes');
        const secondsElement = timerContainer.querySelector('.js-timer-seconds');

        if (!hoursElement || !minutesElement || !secondsElement) {
          console.warn(`[Urgency Timer] Timer elements not found for timer ${index}`);
          return;
        }

        function updateTimer() {
          try {
            const now = new Date();

            // Calculate time until end of day (23:59:59)
            let midnight = new Date();
            midnight.setHours(23, 59, 59, 999);
            midnight.setMilliseconds(midnight.getMilliseconds() + 1);

            let timeDiff = midnight.getTime() - now.getTime();

            // If past midnight, reset for next day
            if (timeDiff <= 0) {
              midnight = new Date();
              midnight.setDate(midnight.getDate() + 1);
              midnight.setHours(23, 59, 59, 999);
              midnight.setMilliseconds(midnight.getMilliseconds() + 1);
              timeDiff = midnight.getTime() - now.getTime();
            }

            const hours = Math.floor(timeDiff / (1000 * 60 * 60));
            const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

            hoursElement.textContent = hours.toString().padStart(2, '0');
            minutesElement.textContent = minutes.toString().padStart(2, '0');
            secondsElement.textContent = seconds.toString().padStart(2, '0');
          } catch (error) {
            console.error(`[Urgency Timer] Error updating timer ${index}:`, error);
          }
        }

        // Initial update
        updateTimer();

        // Update every second
        setInterval(updateTimer, 1000);
      });
    }

    // Start all timers
    startUrgencyTimers();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-hero-lp-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    const isAccordionMode = document.querySelector('.product__heroAccordions');

    // === MODE-SPECIFIC INTERACTIONS ===
    if (isAccordionMode) {
      // Accordion Mode: Toggle expand/collapse
      const accordionHeaders = document.querySelectorAll('.product__heroAccordionHeader');

      accordionHeaders.forEach((header) => {
        header.addEventListener('click', function () {
          const accordion = this.parentElement;
          const content = accordion.querySelector('.product__heroAccordionContent');
          const isActive = accordion.classList.contains('active');

          // Close all accordions
          document.querySelectorAll('.product__heroAccordion').forEach((acc) => {
            acc.classList.remove('active');
            const accContent = acc.querySelector('.product__heroAccordionContent');
            accContent.style.maxHeight = null;
          });

          // Open clicked accordion if it was closed
          if (!isActive) {
            accordion.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        });
      });
    } else {
      // Tab Mode: Switch between tabs
      const tabButtons = document.querySelectorAll('.product__heroTabButton');
      const tabContents = document.querySelectorAll('.product__heroTabContent');

      tabButtons.forEach((button) => {
        button.addEventListener('click', function () {
          const targetTab = this.getAttribute('data-tab');

          tabButtons.forEach((btn) => btn.classList.remove('active'));
          tabContents.forEach((content) => content.classList.remove('active'));

          this.classList.add('active');
          const targetContent = document.querySelector(`[data-content="${targetTab}"]`);
          if (targetContent) {
            targetContent.classList.add('active');
          }
        });
      });
    }

    // === SHARED FUNCTIONALITY (runs once regardless of mode) ===

    // Format review count with commas
    const reviewCountEl = document.querySelector('.js-review-count');
    if (reviewCountEl) {
      const count = reviewCountEl.getAttribute('data-count');
      const formattedCount = parseInt(count).toLocaleString('en-US');
      reviewCountEl.textContent = ` (${formattedCount}+)`;
    }

    // Smooth scroll to testimonials section
    const readAllReviewsBtn = document.querySelector('.product__heroReviewsMore');
    if (readAllReviewsBtn) {
      readAllReviewsBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let targetSelector = readAllReviewsBtn.getAttribute('href');

        if (targetSelector && targetSelector !== '#') {
          targetSelector = targetSelector.replace(/^#/, '');
          let targetElement = document.getElementById(targetSelector);

          if (!targetElement) {
            targetElement = document.querySelector('.' + targetSelector);
          }

          if (!targetElement) {
            targetElement = document.querySelector(readAllReviewsBtn.getAttribute('href'));
          }

          if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 100;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          } else {
            console.warn('[Product Hero Tabs] Scroll target not found:', readAllReviewsBtn.getAttribute('href'));
          }
        }
      });
    }

    // Butter smooth drag scrolling for reviews (Tab mode only)
    const reviewsList = document.querySelector('.product__heroReviewsList');
    if (reviewsList && !isAccordionMode) {
      let isDown = false;
      let startX;
      let scrollLeft;
      let velocity = 0;
      let lastX;
      let lastTime;
      let momentumID;

      reviewsList.addEventListener('mousedown', (e) => {
        isDown = true;
        reviewsList.classList.add('is-dragging');
        startX = e.pageX - reviewsList.offsetLeft;
        scrollLeft = reviewsList.scrollLeft;
        lastX = e.pageX;
        lastTime = Date.now();
        velocity = 0;
        cancelMomentumTracking();
      });

      reviewsList.addEventListener('mouseleave', () => {
        isDown = false;
        reviewsList.classList.remove('is-dragging');
      });

      reviewsList.addEventListener('mouseup', () => {
        isDown = false;
        reviewsList.classList.remove('is-dragging');
        beginMomentumTracking();
      });

      reviewsList.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();

        const x = e.pageX - reviewsList.offsetLeft;
        const walk = (x - startX) * 1.5;
        reviewsList.scrollLeft = scrollLeft - walk;

        const now = Date.now();
        const elapsed = now - lastTime;
        const distance = e.pageX - lastX;
        velocity = distance / elapsed;
        lastX = e.pageX;
        lastTime = now;
      });

      function beginMomentumTracking() {
        cancelMomentumTracking();
        momentumID = requestAnimationFrame(momentumLoop);
      }

      function cancelMomentumTracking() {
        if (momentumID) {
          cancelAnimationFrame(momentumID);
        }
      }

      function momentumLoop() {
        reviewsList.scrollLeft -= velocity * 15;
        velocity *= 0.95;
        if (Math.abs(velocity) > 0.5) {
          momentumID = requestAnimationFrame(momentumLoop);
        }
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
